/**
 * Ashore API
 * All Endpoints to control your ashore account
 *
 * The version of the OpenAPI document: V1
 * Contact: info@ashoreapp.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import ActivityItem from './ActivityItem';
import Job from './Job';
import JobProofLink from './JobProofLink';

/**
 * The DetailResponse model module.
 * @module model/DetailResponse
 * @version V1
 */
class DetailResponse {
    /**
     * Constructs a new <code>DetailResponse</code>.
     * @alias module:model/DetailResponse
     */
    constructor() { 
        
        DetailResponse.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>DetailResponse</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/DetailResponse} obj Optional instance to populate.
     * @return {module:model/DetailResponse} The populated <code>DetailResponse</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new DetailResponse();

            if (data.hasOwnProperty('job')) {
                obj['job'] = Job.constructFromObject(data['job']);
            }
            if (data.hasOwnProperty('activities')) {
                obj['activities'] = ApiClient.convertToType(data['activities'], [ActivityItem]);
            }
            if (data.hasOwnProperty('proofs')) {
                obj['proofs'] = ApiClient.convertToType(data['proofs'], [JobProofLink]);
            }
            if (data.hasOwnProperty('sourceArtIntakeSubmission')) {
                obj['sourceArtIntakeSubmission'] = data['sourceArtIntakeSubmission'];
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>DetailResponse</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>DetailResponse</code>.
     */
    static validateJSON(data) {
        // validate the optional field `job`
        if (data['job']) { // data not null
          Job.validateJSON(data['job']);
        }
        if (data['activities']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['activities'])) {
                throw new Error("Expected the field `activities` to be an array in the JSON data but got " + data['activities']);
            }
            // validate the optional field `activities` (array)
            for (const item of data['activities']) {
                ActivityItem.validateJSON(item);
            };
        }
        if (data['proofs']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['proofs'])) {
                throw new Error("Expected the field `proofs` to be an array in the JSON data but got " + data['proofs']);
            }
            // validate the optional field `proofs` (array)
            for (const item of data['proofs']) {
                JobProofLink.validateJSON(item);
            };
        }

        return true;
    }


}



/**
 * @member {module:model/Job} job
 */
DetailResponse.prototype['job'] = undefined;

/**
 * @member {Array.<module:model/ActivityItem>} activities
 */
DetailResponse.prototype['activities'] = undefined;

/**
 * @member {Array.<module:model/JobProofLink>} proofs
 */
DetailResponse.prototype['proofs'] = undefined;

/**
 * @member {Object} sourceArtIntakeSubmission
 */
DetailResponse.prototype['sourceArtIntakeSubmission'] = undefined;






export default DetailResponse;

